import React from 'react';
import styles from './AboutUs.module.css';
import PortraitCard2 from './PortraitCard2';

const AboutUs = () => {
    return (
        <div className={styles.AboutUs}>
            <div className={styles.ContainerTitle}>
                <div className={styles.ContainerTitleImgBackground} />
                <h1>About us</h1>
            </div>
            <div className={styles.ContainerMembers}>
                <div className={styles.ContainerMembersImgBackground} />

                <div className={styles.AllPortrait}>
                    <PortraitCard2
                        imageUrl={require('../../Images/Pierre.jpg')}
                        name={'Pierre'}
                        text={"Passionate about web development, reading History's books, I also like jogging and swimming without forgetting to have fun with my friends !"}
                    />
                </div>

                {/* 3 groups of social networks members */}
                <div className={styles.ContainerMembersSocial}>
                    {/* Pierre social networks */}
                    <div className={styles.ContainerMembersSocialContent}>
                        <div className={styles.ContainerMembersSocialLinksContent}>
                            <img className={styles.ImgTwitter} src="../../Images/logo-aboutus-twitter.png" alt="Social network Twitter icon - Pierre" />
                        </div>
                        <div className={styles.ContainerMembersSocialLinksContent}>
                            <img className={styles.ImgInstagram} src="../../Images/logo-aboutus-instagram.png" alt="Social network Instagram icon - Pierre" />
                        </div>
                        <div className={styles.ContainerMembersSocialLinksContent}>
                            <img className={styles.ImgFacebook} src="../../Images/logo-aboutus-facebook.png" alt="Social network Facebook icon - Pierre" />
                        </div>
                        <div className={styles.ContainerMembersSocialLinksContent}>
                            <img className={styles.ImgLinkedin} src="../../Images/logo-aboutus-linkedin.png" alt="Social network LinkedIn icon - Pierre" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutUs;